import { useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function QuoteForm({ serviceId, serviceName, cta }) {
  const [f, setF] = useState({ name: "", email: "", phone: "", suburb: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (!f.name || !f.email) return toast.error("Please enter your name and email");
    setBusy(true);
    try { await api.post("/services/quote", { ...f, service_id: serviceId }); setDone(true); toast.success("Quote request sent — we'll be in touch shortly"); }
    catch (err) { toast.error(err?.response?.data?.detail?.[0]?.msg || "Could not send your request"); }
    finally { setBusy(false); }
  };
  if (done) return <div className="rounded-xl border bg-white p-6" data-testid="quote-done"><h3 className="font-bold text-lg text-steel">Thanks — request received</h3><p className="text-sm text-slate-600 mt-1">ACP Online will contact you about {serviceName} shortly.</p></div>;
  return (
    <form id="quote" onSubmit={submit} className="rounded-xl border bg-white p-5 space-y-3" data-testid="quote-form">
      <h3 className="font-heading font-bold text-lg text-steel">{cta || "Request a quote"}</h3>
      <div><Label>Name *</Label><Input value={f.name} onChange={set("name")} data-testid="quote-name" /></div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div><Label>Email *</Label><Input type="email" value={f.email} onChange={set("email")} data-testid="quote-email" /></div>
        <div><Label>Phone</Label><Input value={f.phone} onChange={set("phone")} data-testid="quote-phone" /></div>
      </div>
      <div><Label>Suburb / location</Label><Input value={f.suburb} onChange={set("suburb")} data-testid="quote-suburb" /></div>
      <div><Label>What do you need?</Label><Textarea rows={4} value={f.message} onChange={set("message")} data-testid="quote-message" /></div>
      <Button type="submit" disabled={busy} className="w-full bg-accent text-steel hover:bg-amber-600 font-semibold" data-testid="quote-submit">{busy ? "Sending…" : "Send quote request"}</Button>
    </form>
  );
}
